import styled from 'styled-components';
import { FONT_FAMILY } from '../../../../../common/styles/fontStyles';
import COLORS from '../../../../../common/styles/color-pallete';
import { formatPadding } from '../../../styles';

interface ModalContainerProps {
  padding: Array<number>;
  isCenter?: boolean;
}
export const ModalContainer = styled.div<ModalContainerProps>`
  width: 450px;
  padding: ${({ padding }) => formatPadding(padding)};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${COLORS.white};
  border-radius: 10px;
  div[class*='makeStyles-formControl'] {
    margin: 0 !important;
  }
  .jGTXoq .dropdown-component .input-error-wrapper .ui.fluid.search.selection.dropdown {
    width: 110px !important;
  }
  .modal-body-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .__heading {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 28px;
    font-size: 28px;
    font-weight: 700;
    line-height: 38px;
    text-align: ${({ isCenter }) => (isCenter ? 'center' : 'left')};
    margin-bottom: 16px;
  }
  .button-container {
    position: relative;
    margin-top: 24px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const CloseModalIcon = styled.img`
  display: initial;
  height: 14px;
  width: 14px;
  align-self: flex-end;
  justify-self: flex-end;
  cursor: pointer;
`;

export const CancelButton = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.textLinkBlue};
  cursor: pointer;
  text-align: center;
`;

export const RecipientInfoContainer = styled.div`
  width: 100%;
  .info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
  }
  .bold-text {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
  }

  .__text {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
`;
